import React from "react";
import { useParams, Link } from "react-router-dom";
import productsData from "../data/products.json";
import "../styles/Produto.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Produto = () => {
    const { id } = useParams();
    const produto = productsData.find((p) => p.id === parseInt(id));

    const getImage = (file) => require(`../assets/${file}`);

    if (!produto) {
        return (
            <div className="produto-notfound">
                <h2>Produto não encontrado</h2>
                <Link to="/produtos" className="btn-primary">
                    Voltar para Produtos
                </Link>
            </div>
        );
    }

    const outrosProdutos = productsData
        .filter((p) => p.id !== produto.id)
        .sort(() => Math.random() - 0.5)
        .slice(0, 4);

    return (
        <section className="produto-page">
            <div className="page-hero">
                <div className="page-hero__overlay" />
                <div className="page-hero__content">
                    <h1 className="page-hero__title">{produto.title}</h1>
                    <div className="page-breadcrumbs">
                        <span className="page-breadcrumbs__link">Início</span>
                        <span className="page-breadcrumbs__sep">›</span>
                        <span className="page-breadcrumbs__current">{produto.title}</span>
                    </div>
                </div>
            </div>

            <div className="produto-container produto-layout">
                <div className="produto-gallery-col">
                    <Swiper
                        modules={[Navigation]}
                        navigation
                        spaceBetween={20}
                        slidesPerView={1}
                        loop
                        className="produto-swiper"
                    >
                        {produto.images.map((img, i) => (
                            <SwiperSlide key={i}>
                                <img
                                    src={getImage(img)}
                                    alt={`${produto.title}-${i}`}
                                    className="produto-slide-img"
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <div className="produto-thumbs">
                        {produto.images.map((img, i) => (
                            <div key={i} className="thumb">
                                <img src={getImage(img)} alt={`${produto.title}-${i}`} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="produto-info-col">
                    <h2>{produto.title}</h2>
                    <p className="produto-desc">{produto.description}</p>

                    <a
                        href={`https://wa.me/5511999999999?text=Olá, tenho interesse em ${produto.title}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-whatsapp-lg"
                    >
                        Solicitar Orçamento Personalizado
                    </a>

                    <div className="produto-specs">
                        <h4>Especificações Técnicas</h4>
                        <ul>
                            {produto.specs.map((spec, i) => (
                                <li key={i}>{spec}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="produto-outros">
                <h2>Outros Produtos</h2>
                <div className="outros-grid">
                    {outrosProdutos.map((p) => (
                        <Link key={p.id} to={`/produto/${p.id}`} className="outro-card">
                            <div className="outro-image">
                                <img src={getImage(p.images[0])} alt={p.title} />
                                <div className="outro-overlay">
                                    <span>Ver Detalhes</span>
                                </div>
                            </div>
                            <h3>{p.title}</h3>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Produto;
